<template>
  <div>
    <widget>
      <template slot="title">
        Fahrzeugsuche
      </template>
      <template slot="content">
        <div class="row">
          <section class="col col-md-4">
            <label>Kategorie</label>
            <div class="select">
              <i />
              <select v-model="category">
                <option value="">
                  Feld ignorieren
                </option>
                <option value="Neuwagen">
                  Neuwagen
                </option>
                <option value="TZL">
                  Kurzzulassung
                </option>
                <option value="Jahreswagen">
                  Jahreswagen
                </option>
                <option value="Gebrauchtwagen">
                  Gebrauchtwagen
                </option>
                <option value="Vorfuehrwagen">
                  Vorführwagen
                </option>
                <option value="Mietwagen">
                  Mietwagen
                </option>
              </select>
            </div>
          </section>

          <section class="col col-md-4">
            <label>Kilometerstand von</label>
            <div class="input">
              <input
                v-model="mileageFrom"
                type="text"
                placeholder="Kilometerstand"
              >
            </div>
          </section>

          <section class="col col-md-4">
            <label>Kilometerstand bis</label>
            <div class="input">
              <input
                v-model="mileageTo"
                type="text"
                placeholder="Kilometerstand"
              >
            </div>
          </section>
        </div>

        <div class="row">
          <section class="col col-md-4">
            <label>Hersteller</label>
            <div class="select">
              <select v-model="manufacturer">
                <option value="">
                  Feld ignorieren
                </option>
                <option
                  v-for="item in manufacturers"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
              <i />
            </div>
          </section>

          <section class="col col-md-4">
            <label>Model</label>
            <div class="select">
              <select v-model="model">
                <option value="">
                  Feld ignorieren
                </option>
                <option
                  v-for="item in models"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
              <i />
            </div>
          </section>

          <section class="col col-md-4">
            <label>Fahrzeugtitel enthält</label>
            <div class="input">
              <input
                v-model="title"
                type="text"
                placeholder="Fahrzeugtitel"
              >
            </div>
          </section>
        </div>

        <div class="row">
          <section class="col col-md-4">
            Angebotspreis von
            <div class="input-group">
              <input
                v-model="priceFrom"
                class="form-control"
                placeholder="Angebotspreis"
              >
              <span class="input-group-addon">
                <span class="onoffswitch bruttonetto">
                  <input
                    id="priceFromGross"
                    v-model="priceFromGross"
                    type="checkbox"
                    class="onoffswitch-checkbox"
                    checked="checked"
                  >
                  <label
                    class="onoffswitch-label"
                    for="priceFromGross"
                  >
                    <span
                      data-swchoff-text="Netto"
                      data-swchon-text="Brutto"
                      class="onoffswitch-inner"
                    />
                    <span class="onoffswitch-switch" />
                  </label>
                </span>
              </span>
            </div>
          </section>

          <section class="col col-md-4">
            Angebotspreis bis
            <div class="input-group">
              <input
                v-model="priceTo"
                class="form-control"
                placeholder="Angebotspreis"
              >
              <span class="input-group-addon">
                <span class="onoffswitch bruttonetto">
                  <input
                    id="priceToGross"
                    v-model="priceToGross"
                    type="checkbox"
                    class="onoffswitch-checkbox"
                    checked="checked"
                  >
                  <label
                    class="onoffswitch-label"
                    for="priceToGross"
                  >
                    <span
                      data-swchoff-text="Netto"
                      data-swchon-text="Brutto"
                      class="onoffswitch-inner"
                    />
                    <span class="onoffswitch-switch" />
                  </label>
                </span>
              </span>
            </div>
          </section>

          <section class="col col-md-4">
            <label>Status</label>
            <div class="select">
              <select v-model="status">
                <option value="">
                  Feld ignorieren
                </option>
                <option value="stockandupcoming">
                  Vorlauf und Lager
                </option>
                <option value="1">
                  Bestellt / Vorlauf
                </option>
                <option value="2">
                  Bestellt für Kunden
                </option>
                <option value="6">
                  Rechnung erhalten / nicht geliefert
                </option>
                <option value="3">
                  Auf Lager
                </option>
                <option value="4">
                  Verkauft
                </option>
                <option value="5">
                  Ausgeliefert
                </option>
              </select>
              <i />
            </div>
          </section>
        </div>

        <div class="row">
          <section class="col col-md-4">
            <label>Leistung von</label>
            <div class="input">
              <input
                v-model="powerFrom"
                type="text"
                placeholder="Leistung"
              >
            </div>
          </section>

          <section class="col col-md-4">
            <label>Leistung bis</label>
            <div class="input">
              <input
                v-model="powerTo"
                type="text"
                placeholder="Leistung"
              >
            </div>
          </section>

          <section class="col col-md-4">
            <label>Getriebeart</label>
            <div class="select">
              <select v-model="transmissionType">
                <option value="">
                  Feld ignorieren
                </option>
                <option value="manual">
                  Schaltgetriebe
                </option>
                <option value="automatic">
                  Automatikgetriebe
                </option>
              </select>
              <i />
            </div>
          </section>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn btn-primary"
          @click="search"
        >
          Suchen
        </button>
      </template>
    </widget>

    <widget
      v-if="vehicles.length"
      no-padding
    >
      <template slot="title">
        {{ vehicles.length }} Treffer
      </template>
      <template slot="content">
        <table class="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>Hersteller / Model / Titel</th>
              <th>Farbe</th>
              <th>Typ</th>
              <th>KM</th>
              <th>Angebotspreis</th>
              <th>Lagerplatz</th>
              <th class="smallest" />
            </tr>
          </thead>
          <tbody>
            <template v-if="vehicles.length">
              <tr
                v-for="vehicle in vehicles"
                :key="vehicle.id"
              >
                <template v-if="vehicle.item_shared_title.length">
                  <td>
                    {{ vehicle.item_shared_title }}

                    <template v-if="vehicle.options.length">
                      <strong class="special-equipments-title">Sonderausstattungen</strong>
                      <ul class="special-equipments-listing">
                        <li
                          v-for="option in vehicle.options"
                          :key="option.item_id"
                        >
                          {{ option.item_id }} {{ option.item_title }}
                        </li>
                      </ul>
                    </template>
                  </td>
                </template>
                <template v-else>
                  <td>{{ vehicle.item_mobile_make }} {{ vehicle.item_mobile_model }}</td>
                </template>

                <template v-if="!!vehicle.item_mobilede_data">
                  <template v-if="!!vehicle.item_mobilede_data.manufacturerColorName">
                    <td>{{ vehicle.item_mobilede_data.manufacturerColorName }}</td>
                  </template>
                  <template v-else>
                    <td />
                  </template>
                </template>
                <template v-else-if="vehicle.exteriorColor">
                  <td>{{ vehicle.exteriorColor }}</td>
                </template>
                <template v-else>
                  <td />
                </template>

                <td>{{ vehicle.item_type }}</td>
                <td>{{ vehicle.item_km }}</td>


                <td>
                  <template v-if="vehicle.item_price_customer > 0">
                    <strong>Angebotspreis:</strong> {{ vehicle.item_price_customer | price }}
                    <br>
                  </template>

                  <template v-if="vehicle.item_net_list_price_invoice > 0">
                    <strong>UPE:</strong> {{ vehicle.item_net_list_price_invoice | price }}
                    <br>
                  </template>
                </td>

                <td>{{ vehicle.item_stock_title }}</td>
                <td class="text-right smallest">
                  <button
                    class="btn btn-primary btn-xs"
                    @click="useVehicle(vehicle)"
                  >
                    Auswählen
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </template>
    </widget>
  </div>
</template>

<script>


import { mapActions } from 'vuex'
import _ from 'lodash'

import Widget from '../general/widget.vue'

export default {

  components: {
    Widget
  },

  data() {
    return {
      category: '',
      mileageFrom: '',
      mileageTo: '',
      manufacturer: '',
      manufacturers: [],
      model: '',
      models: [],
      title: '',
      priceFrom: '',
      priceFromGross: true,
      priceTo: '',
      priceToGross: true,
      status: '',
      powerFrom: '',
      powerTo: '',
      transmissionType: '',
      vehicles: [],
      type: false
    }
  },

  watch: {
    manufacturer() {
      axios.post(`${process.env.VUE_APP_PROVIDER}/xhr/vehicle_models`, { manufacturer: this.manufacturer }).then((response) => {
        this.models = response.data
      })
    }
  },

  created() {
    axios.get(`${process.env.VUE_APP_PROVIDER}/xhr/vehicle_manufacturers`).then((response) => {
      this.manufacturers = response.data
    })
  },

  methods: {
    ...mapActions([
      'storeCashSaleVehicle',
      'storeCashSaleConfiguration'
    ]),

    search() {
      const parameters = {
        category: this.category,
        mileageFrom: this.mileageFrom,
        mileageTo: this.mileageTo,
        manufacturer: this.manufacturer,
        manufacturers: this.manufacturers,
        model: this.model,
        models: this.models,
        title: this.title,
        priceFrom: this.priceFrom,
        priceFromGross: this.priceFromGross,
        priceTo: this.priceTo,
        priceToGross: this.priceToGross,
        status: this.status,
        powerFrom: this.powerFrom,
        powerTo: this.powerTo,
        transmissionType: this.transmissionType
      }

      axios.post(`${process.env.VUE_APP_PROVIDER}/xhr/vehicle_search`, parameters).then((response) => {
        this.vehicles = response.data

        _.each(this.vehicles, (item) => {
          if (item.item_mobilede_data && item.item_mobilede_data.length) {
            // eslint-disable-next-line no-param-reassign
            item.item_mobilede_data = JSON.parse(item.item_mobilede_data)
          }
        })
      })
    },

    useVehicle(vehicle) {
      this.storeCashSaleVehicle(vehicle)
      this.$emit('done', vehicle)
    }
  }
}

</script>

<style scoped>

    .special-equipments-title {
        margin: 10px 0;
        display: block;
        font-size: 11px;
    }

    .special-equipments-listing {
        margin-left: 30px;
        font-size: 11px;
    }

    .smallest {
        width: 1px;
    }
</style>
